import './style/index.js';

import _Textarea from './textarea';

export type { TextareaProps } from './textarea';
export const Textarea = _Textarea;
export default Textarea;

export * from './type';
